<template>
  <div class="new-product page dashboard">
    <div class="content">
      <div class="title-bar">
        <div class="title">{{isEdit ? 'Edit Product' : 'New Product'}}</div>
      </div>
      <form v-on:submit.prevent="createProduct">
        <div class="page-content">
          <div class="product-image">
            <label
              :style="{backgroundImage: `url(${mainImagePath})`}"
              for="main-image"
              class="main-image btn"
            >
              <p v-if="!product.mainImage">Select an image</p>
            </label>
            <input id="main-image" class="file-input" type="file" @change="handleMainImageSelected" />
            <div class="image-list" style="display: grid; grid-template-columns: auto auto auto;">
              <div v-for="(image, idx) in product.listImage" :key="idx" style="position: relative;">
                <p class="btn remove-option" style="position: absolute; right: 18px; top: -9px;" v-on:click="removeListImages(idx)">x</p>
                <img
                  alt
                  :src="image.path || getAPIImage(image)"
                  style="margin-bottom: 10px;"
                  class="image"
                />
              </div>
              <label for="list-image" class="add-image btn">Add</label>
              <input id="list-image" type="file" class="file-input" @change="addListImage" />
            </div>
          </div>
          <div class="product-info">
            <div class="product-detail">
              <input type="text" class="input" v-model="product.name" placeholder="Product Name English" />
              <input type="text" class="input" v-model="product.nameKh" placeholder="Product Name Khmer" />
              <input type="text" class="input" v-model="product.nameZh" placeholder="Product Name China" />
              <div v-if="!this.product.category" class="row category">
                <p class="btn" v-on:click="openCategoryModal">Category</p>
              </div>
              <div v-if="this.product.category" class="row selected-category">
                <p>{{ this.product.category.en }}</p>
                <p class="btn" v-on:click="openCategoryModal">Change</p>
              </div>
              <input type="text" class="input" v-model="product.tag" placeholder="Tags" />
              <!-- <select class="input" v-model="product.type">
                  <option selected value="normal">Normal</option>
                  <option value="spacial">Spacial</option>
                  <option value="1688">1688</option>
              </select> -->
              <input
                type="number" step="0.001"
                class="input"
                v-model="product.price.maxPrice"
                placeholder="Default Price"
              />
              <input
                type="number" step="0.001"
                class="input"
                v-model="product.promoPrice.maxPrice"
                placeholder="Promo Price"
              />
            </div>
            <div class="variations">
              <div class="add-variation" v-if="product.variations.length < 2">
                <p class="btn" v-on:click="openNewVariationModal">Add Variation</p>
              </div>
              <div
                class="variation-item"
                v-for="(variation, vIdx) in product.variations"
                :key="vIdx"
              >
                <div class="vairation-header">
                  <p class="bold">Name English: {{ variation.name }}</p>
                  <p class="bold">Khmer: {{ variation.nameKh }}</p>
                  <p class="bold">China: {{ variation.nameZh }}</p>
                  <p class="remove-variation btn" v-on:click="removeVariation(vIdx)">Remove</p>
                </div>
                <div class="option-list">
                  <div class="option" v-for="(option, idx) in variation.data" :key="idx">
                    <p class="btn remove-option" v-on:click="removeOptions(vIdx, idx)">x</p>
                    <div
                      v-if="variation.hasImage"
                      class="option-image"
                      :style="`backgroundImage: url(${option.image ? option.image.path : ''})`"
                    ></div>
                    <div class="option-info">
                      <p class="bold">English: {{ option.value }}</p>
                      <p class="bold">Khmer: {{ option.valueKh }}</p>
                      <p class="bold">China: {{ option.valueZh }}</p>
                    </div>
                  </div>
                  <div
                    class="add-option btn"
                    v-on:click="openVariationOptionModal(vIdx, variation)"
                  >
                    <p>Add Option</p>
                  </div>
                </div>
              </div>
              <div class="sku-map">
                <form v-if="product.variations.length > 0" v-on:submit.prevent="addSkuMap">
                  <table>
                    <tr>
                      <th v-if="product.variations.length > 0">Variation 1</th>
                      <th v-if="product.variations.length > 1">Variation 2</th>
                      <th>Price</th>
                      <th>Promo price</th>
                      <th>Minimum Quantity</th>
                      <th>Action</th>
                    </tr>
                    <tr>
                      <td v-if="product.variations.length > 0">
                        <select class="input" v-model="newSkuMap.variation1">
                          <option
                            v-for="(option, key) in product.variations[0].data"
                            :key="key"
                            :value="option.value"
                          >{{ option.value }}</option>
                        </select>
                      </td>
                      <td v-if="product.variations.length > 1">
                        <select class="input" v-model="newSkuMap.variation2">
                          <option
                            v-for="(option, key) in product.variations[1].data"
                            :key="key"
                            :value="option.value"
                          >{{ option.value }}</option>
                        </select>
                      </td>
                      <td>
                        <input class="input" type="number" step="0.001" v-model="newSkuMap.price" />
                      </td>
                      <td>
                        <input class="input" type="number" step="0.001" v-model="newSkuMap.promoPrice" />
                      </td>
                      <td>
                        <input class="input" type="number" step="0.001" v-model="newSkuMap.minimumQuantity" />
                      </td>
                      <td>
                        <input class="btn" type="submit" value="Add" />
                      </td>
                    </tr>
                    <tr v-for="(price, idx) in skuMap" :key="idx">
                      <td v-if="product.variations.length > 0">{{ price.variation1 }}</td>
                      <td v-if="product.variations.length > 1">{{ price.variation2 }}</td>

                      <td>
                        <input class="input" type="number" step="0.001" v-model="price.price" />
                      </td>
                      <td>
                        <input class="input" type="number" step="0.001" v-model="price.promoPrice" />
                      </td>
                      <td>
                        <input class="input" type="number" step="0.001" v-model="price.minimumQuantity" />
                      </td>
                      <td v-on:click="deleteSkuMap(idx)">Delete</td>
                    </tr>
                  </table>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div class="add-product" v-if="product.mainImage && product.name && product.price.maxPrice">
          <button type="submit" class="btn" v-if="!uploadingImage">{{isEdit ? 'Update product': 'Add product'}}</button>
          <p class="loading" v-if="uploadingImage">Uploading Images . . .</p>
        </div>
        <div class="add-product" v-else>
          <p class="loading">Please field required information . . .</p>
        </div>
      </form>
    </div>
    <NewVariationModal
      :closeModal="closeNewVariationModal"
      v-if="newVariationModalOpened"
      :onSubmit="addVariation"
    />
    <SelectCategoryModal
      :closeModal="closeCategoryModal"
      v-if="categoryModalOpened"
      :onSubmit="selectCategory"
    />
    <VariationOptionModal
      :closeModal="closeVariationOptionModal"
      v-if="variationOptionModalOpened"
      :hasImage="focusedVariation.variation.hasImage"
      :onSubmit="addOption"
    />
  </div>
</template>
<script>
import NewVariationModal from "./NewVariationModal";
import SelectCategoryModal from "./SelectCategoryModal";
import VariationOptionModal from "./VariationOptionModal";
import { FileUpload } from "../../handler";
import { API_URL } from "../../const";
export default {
  components: {
    NewVariationModal,
    SelectCategoryModal,
    VariationOptionModal,
  },
  data() {
    return {
      newVariationModalOpened: false,
      categoryModalOpened: false,
      variationOptionModalOpened: false,
      uploadingImage: false,
      product: {
        listImagePath: [],
        mainImage: null,
        listImage: [],
        name: "",
        nameKh: "",
        nameZh: "",
        type: "normal",
        price: {
          minPrice: 0,
          maxPrice: null,
        },
        promoPrice: {
          minPrice: 0,
          maxPrice: null
        },
        variations: [],
      },
      focusedVariation: null,
      skuMap: [],
      newSkuMap: {
        variation1: null,
        variation2: null,
        price: null,
        promoPrice: null,
        minimumQuantity: null,
      },
      isEdit: false
    };
  },
  mounted() {
    if(this.$route.query.edit) {
      if(!this.editProduct._id) {
        return this.$router.go(-1);
      }

      this.isEdit = true;

      this.product = this.editProduct;
      this.selectCategory(this.product.category);
      this.skuMap = this.product.skuMap.map(item => {
        let variation1 = null;
        let variation2 = null;
        if(this.product.variations.length == 2) {
          [variation1, variation2] = item.skuMap.split(';')
        } else {
          variation1 = item.skuMap
        }

        return {
          variation1,
          variation2,
          price: item.price,
          promoPrice: item.promoPrice,
          minimumQuantity: item.minimumQuantity,
        }
      });
    }
  },
  methods: {
    getAPIImage(path) {
      if(path) {
        return API_URL + '/' + path;
      }

      return '';
    },
    openNewVariationModal() {
      this.newVariationModalOpened = true;
    },
    closeNewVariationModal() {
      this.newVariationModalOpened = false;
    },
    openCategoryModal() {
      this.categoryModalOpened = true;
    },
    closeCategoryModal() {
      this.categoryModalOpened = false;
    },
    openVariationOptionModal(idx, variation) {
      this.focusedVariation = { idx, variation };
      this.variationOptionModalOpened = true;
    },
    closeVariationOptionModal() {
      this.variationOptionModalOpened = false;
    },
    handleMainImageSelected(e) {
      const image = e.target.files[0];
      this.loading = true;
      this.product.mainImage = image;
      this.product.mainImage.path = URL.createObjectURL(this.product.mainImage);
      this.loading = false;
    },
    addListImage(e) {
      const image = e.target.files[0];
      image.path = URL.createObjectURL(image);
      this.product.listImage = [...this.product.listImage, image];
    },
    removeListImage(idx) {
      this.product.listImage = this.product.listImage.filter(
        (l, index) => (index, idx)
      );
    },
    addVariation(variation) {
      this.product.variations = [...this.product.variations, variation];
    },
    removeVariation(idx) {
      this.product.variations = this.product.variations.filter(
        (v, index) => idx !== index
      );
    },
    addOption(option) {
      if (
        this.product.variations[this.focusedVariation.idx].data
          .map((d) => d.value)
          .includes(option.value)
      ) {
        alert("Option already exist");
      } else {
        this.product.variations[this.focusedVariation.idx].data = [
          ...this.product.variations[this.focusedVariation.idx].data,
          option,
        ];
      }
    },
    removeOptions(vIdx, idx) {
      this.product.variations[vIdx].data = this.product.variations[
        vIdx
      ].data.filter((o, index) => idx !== index);
    },
    removeListImages(idx) {
      this.product.listImage = this.product.listImage.filter(
        (l, index) => index !== idx
      );
    },
    addSkuMap() {
      this.skuMap = [...this.skuMap, this.newSkuMap];
      this.newSkuMap = {
        variation1: null,
        variation2: null,
        price: null,
        promoPrice: null,
        minimumQuantity: null,
      };
    },
    deleteSkuMap(idx) {
      this.skuMap = this.skuMap.filter((m, index) => idx !== index);
    },
    selectCategory(category) {
      this.product.category = category;
    },
    async createProduct() {
      this.uploadingImage = true;
      if(this.product.mainImage.name) {
        const mainImageFile = await FileUpload.uploadFile(this.product.mainImage);
        this.product.mainImagePath = mainImageFile.path;
      }
      if(!this.product.listImagePath) {
        this.product.listImagePath = [];
      }
      for (let [idx, i] of this.product.listImage.entries()) {
        if(this.product.listImage[idx]?.name) {
          const file = await FileUpload.uploadFile(i);
          this.product.listImagePath[idx] = file.path;
        } else {
          this.product.listImagePath[idx] = this.product.listImage[idx];
        }
      }
      for (let [vIdx, v] of this.product.variations.entries()) {
        if (v.hasImage) {
          for (let [oIdx, o] of v.data.entries()) {
            if(o.image) {
              const optionImage = await FileUpload.uploadFile(o.image);
              this.product.variations[vIdx].data[oIdx].imagePath =
                optionImage.path;
              }
            }
        }
      }
      const data = {
        name: this.product.name,
        nameKh: this.product.nameKh,
        nameZh: this.product.nameZh,
        mainImage: this.product.mainImagePath,
        listImage: this.product.listImagePath,
        price: {
          minPrice: this.product.price.maxPrice,
          maxPrice: this.product.price.maxPrice,
        },
        promoPrice: {
          minPrice: this.product.promoPrice.maxPrice,
          maxPrice: this.product.promoPrice.maxPrice
        },
        merchant: this.merchantId,
        tag: this.product.tag,
        type: this.product.type,
        category: this.product.category?._id,
        variations: this.product.variations.map((v) => {
          return {
            name: v.name,
            nameKh: v.nameKh,
            nameZh: v.nameZh,
            data: v.data.map((o) => ({
              value: o.value,
              valueKh: o.valueKh,
              valueZh: o.valueZh,
              image: o.imagePath ? o.imagePath : undefined,
            })),
          };
        }),
        skuMap: this.skuMap.map((m) => {
          let skuMap = m.variation2
            ? `${m.variation1.toString()};${m.variation2.toString()}`
            : m.variation1.toString();
          return {
            skuMap,
            price: m.price,
            promoPrice: m.promoPrice,
            minimumQuantity: m.minimumQuantity,
          };
        }),
      };
      
      const done = await this.$store.dispatch(this.$route.query.edit ? "productsModule/updateProduct" : "productsModule/createProduct", {
        data,
        productId: this.product?._id
      });

      this.uploadingImage = false;
      if (done) {
        this.$router.go(-1);
      }
    },
  },
  computed: {
    merchantId() {
      return this.$route.query.merchantId;
    },
    editProduct(){
      return this.$store.state.productsModule.editProduct;
    },
    mainImagePath(){
      return this.product?.mainImage?.path || this.getAPIImage(this.product.mainImage);
    }
  },
};
</script>

<style></style>
